// @ts-nocheck
import { useFormik } from 'formik';
import Form from 'react-bootstrap/Form';
import { useEffect } from 'react';
import Select from 'react-select';
import {
  EditOrganization,
  cleanOrganization,
  getOrganization,
  getOrganizations
} from '../../../../store/HR/Organizations/organizationSlice';
import { formOrganization } from '../../../ValidationForm/validationSchema';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import useLookupOrgType from '@hooks/Lookups/use-Lookup-OrgType';
import useLookupOrgClass from '@hooks/Lookups/use-Lookup-OrgClass';
import useGetLocations from '@hooks/HRSetting/use-get-locations';
import Loading from '@components/Shared/Loader/Loading';
import useGetChartAccountsDetailsList from '@hooks/Finance/useGetChartAccountsDetailsList';
import SwalAlert from '@components/Shared/Alert/SwalAlert';
import { DynamicInput } from '../DynamicInput/DynamicInput';
import useGetOrganizations from '@hooks/HR/use-get-organizations';
import useGetGlLedgersList from '@hooks/Finance/useGetGlLedgersList';

const EditFormDepartments = props => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { ORG_TYPE } = useLookupOrgType();
  const { dataORGCLASS } = useLookupOrgClass();
  const { Locations } = useGetLocations();
  const { OperatingUnitOptions } = useGetOrganizations();
  const { OptionsLedgers } = useGetGlLedgersList();
  const { loadingById, error, Organization } = useSelector(state => state.Organizations);
  const { OptionsAccounts, loading: loadingAccounts } = useGetChartAccountsDetailsList();

  useEffect(() => {
    dispatch(getOrganization(props.id));

    return () => {
      dispatch(cleanOrganization());
    };
  }, [dispatch, props.id]);

  const formik = useFormik({
    initialValues: {
      externalFlag: Organization ? Organization.externalFlag : false,

      InternalOrExternal: Organization.externalFlag ? 'External' : 'Internal',

      name2: Organization ? Organization.name2 : '',
      name: Organization ? Organization.name : '',
      locationId: Organization ? Organization.locationId : '',
      dateFrom: Organization ? Organization.dateFrom : '',
      description: Organization ? Organization.description : '',
      type: Organization ? Organization.type : '',
      organizationInformation: Organization ? Organization.organizationInformation : '',
      // accountId: Organization ? Organization.accountId : '',
      operatingUnitId: Organization ? Organization.operatingUnitId : '',
      ledgerId: Organization ? Organization.ledgerId : '',
      //

      parameters: Organization
        ? Organization?.parameters?.map(m => ({
            organizationCategoryId: m.organizationCategoryId,
            // parameterValue: m.value,
            type: m.type,
            lable: m.lable,
            lable2: m.lable2,
            value: m.value
          }))
        : [],
      //
      // commercialRegistrationNumber: Organization ? Organization.commercialRegistrationNumber : '',
      commercialRegistrationNumber:
        Organization && Organization.commercialRegistrationNumber != null
          ? Organization.commercialRegistrationNumber
          : '',
      // vatNumber: Organization ? Organization.vatNumber : '',
      vatNumber: Organization && Organization.vatNumber != null ? Organization.vatNumber : ''
    },

    enableReinitialize: true,
    validationSchema: formOrganization(t),

    onSubmit: (values, { resetForm }) => {
      // debugger;
      if (values.type === '30' && Organization.type !== '30') {
        SwalAlert({
          icon: 'info',
          text: 'يرجى التواصل مع الدعم الفني لإتمام عملية إضافة شركة جديدة.'
        });
        formik.setSubmitting(false);
        return;
      }
      dispatch(
        EditOrganization({
          id: Organization.id,
          businessGroupId: null,
          locationId: values.locationId || null,
          dateFrom: values.dateFrom,
          name: values.name,
          name2: values.name2,
          externalFlag: values.InternalOrExternal === 'External' ? true : false,
          description: values.description,
          type: values.type,
          organizationInformation: values.organizationInformation,
          dateTo: null,
          // accountId: values.accountId,
          operatingUnitId: values.operatingUnitId || null,
          ledgerId: values.ledgerId || null,
          parameters: values.parameters?.map(m => ({
            organizationCategoryId: m.organizationCategoryId,
            parameterValue: m.value
          })),

          commercialRegistrationNumber: values.commercialRegistrationNumber,
          vatNumber: values.vatNumber
        })
      )
        .unwrap()
        .then(() => {
          resetForm();
          CustomAlert({ action: 'Edit' });
          // dispatch(getOrganization(props.id));

          // Navigate(-1, { replace: true });
          dispatch(getOrganizations());
        })
        .catch(error => {
          CustomAlert({ action: 'Error' });
          formik.setSubmitting(false);
        });
    }
  });
  // console.log(formik.values);
  // جلب قيم معلومات الادارة  والوصول الى مسمياتها من خلال القيم
  const LabelArray =
    Organization &&
    formik.values.organizationInformation?.split(',')?.map(value => {
      const label = dataORGCLASS?.find(f => f.value === value.trim());
      return label;
    });



    console.log(formik.values.parameters);
    

  return (
    <>
      <Loading loading={loadingById} error={error}>
        <Form onSubmit={formik.handleSubmit}>
          <div className='row'>
            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('LocalName')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='name2'
                  onChange={formik.handleChange}
                  value={formik.values.name2 || ''}
                  isInvalid={formik.touched.name2 && formik.errors.name2}
                />
                <Form.Control.Feedback type='invalid'>{formik.errors.name2}</Form.Control.Feedback>
              </div>
            </div>

            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('GlobalName')}</label>
                <Form.Control
                  className='form-control'
                  placeholder='الاسم بالانجليزي'
                  type='text'
                  autoComplete='off'
                  name='name'
                  onChange={formik.handleChange}
                  value={formik.values.name || ''}
                  isInvalid={formik.touched.name && formik.errors.name}
                />
                <Form.Control.Feedback type='invalid'>{formik.errors.name}</Form.Control.Feedback>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'> {t('location')}</label>
                <Form.Select
                  className='form-select'
                  name='locationId'
                  onChange={formik.handleChange}
                  value={formik.values.locationId || ''}
                  isInvalid={formik.touched.locationId && formik.errors.locationId}
                >
                  <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                  {Locations?.map((item, idx) => (
                    <option key={++idx} value={item.id}>
                      {i18n.language === 'ar' ? item.name2 : item.name}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type='invalid'>
                  {formik.errors.locationId}
                </Form.Control.Feedback>
              </div>
            </div>

            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('InternalOrExternal')}</label>
                <Form.Select
                  className='form-select'
                  name='InternalOrExternal'
                  onChange={formik.handleChange}
                  value={formik.values.InternalOrExternal}
                  isInvalid={formik.touched.InternalOrExternal && formik.errors.InternalOrExternal}
                >
                  <option key={1} value=''>
                    {i18n.language === 'ar' ? 'إختر' : 'Choose'}
                  </option>
                  <option key={2} value='Internal'>
                    {i18n.language === 'ar' ? 'داخلي' : 'Internal'}
                  </option>
                  <option key={3} value='External'>
                    {i18n.language === 'ar' ? 'خارجي' : 'External'}
                  </option>
                </Form.Select>
                <Form.Control.Feedback type='invalid'>
                  {formik.errors.InternalOrExternal}
                </Form.Control.Feedback>
              </div>
            </div>
          </div>

          <div className='row'>
            {!props.type && (
              <div className='col-xl-6'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('Type')}</label>
                  <Form.Select
                    disabled={props.type !== undefined}
                    className='form-select'
                    name='type'
                    onChange={formik.handleChange}
                    value={formik.values.type || ''}
                    isInvalid={formik.touched.type && formik.errors.type}
                  >
                    <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                    {ORG_TYPE?.map((item, idx) =>
                      item.list?.map(list => (
                        <option key={++idx} value={list.lookupCode}>
                          {i18n.language === 'ar' ? list.meaning2 : list.meaning}
                        </option>
                      ))
                    )}
                  </Form.Select>
                  <Form.Control.Feedback type='invalid'>{formik.errors.type}</Form.Control.Feedback>
                </div>
              </div>
            )}
            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Start Date')}</label>
                <Form.Control
                  type='date'
                  id='START_DATE'
                  className='form-control'
                  name='dateFrom'
                  onChange={formik.handleChange}
                  value={formik.values.dateFrom || ''}
                  isInvalid={!!formik.errors.dateFrom}
                />

                <Form.Control.Feedback type='invalid'>
                  {formik.errors.dateFrom}
                </Form.Control.Feedback>
              </div>
            </div>

            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('OperationUnit')}</label>
                <Select
                  classNamePrefix='react-select'
                  // className="text-center"
                  // isLoading={loadingAccounts}
                  isSearchable={true}
                  isClearable
                  options={OperatingUnitOptions}
                  value={
                    OperatingUnitOptions?.find(f => f.value === formik.values.operatingUnitId) ||
                    null
                  }
                  onChange={option => formik.setFieldValue('operatingUnitId', option?.value)}
                  placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                />
              </div>
            </div>

            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('GeneralLedger')}</label>
                <Select
                  classNamePrefix='react-select'
                  // className="text-center"
                  // isLoading={loadingAccounts}
                  isSearchable={true}
                  isClearable
                  options={OptionsLedgers}
                  value={OptionsLedgers?.find(f => f.value === formik.values.ledgerId) || null}
                  onChange={option => formik.setFieldValue('ledgerId', option?.value)}
                  placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                />
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('CommercialRegistrationNumber')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='commercialRegistrationNumber'
                  onChange={formik.handleChange}
                  value={formik.values.commercialRegistrationNumber || ''}
                  maxLength='10'
                  pattern='\d{10}'
                  isInvalid={
                    formik.touched.commercialRegistrationNumber &&
                    formik.errors.commercialRegistrationNumber
                  }
                />
                <Form.Control.Feedback type='invalid'>
                  {formik.errors.commercialRegistrationNumber}
                </Form.Control.Feedback>
              </div>
            </div>
            <div className='col-xl-6  '>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('VatNumber')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='vatNumber'
                  onChange={formik.handleChange}
                  value={formik.values.vatNumber || ''}
                  maxLength='15'
                  pattern='\d{15}'
                  isInvalid={formik.touched.vatNumber && formik.errors.vatNumber}
                />
                <Form.Control.Feedback type='invalid'>
                  {formik.errors.vatNumber}
                </Form.Control.Feedback>
              </div>
            </div>
          </div>

          {!props.type && (
            <div className='col-xl-12'>
              <div className='mb-3'>
                <label className='form-label'>
                  {t('Classification')} <span className='text-danger'>*</span>
                </label>
                <Select
                  isMulti
                  options={dataORGCLASS}
                  classNamePrefix='react-select'
                  name='organizationInformation'
                  isSearchable={true}
                  value={LabelArray}
                  onChange={e => {
                    console.log(e);
                    const formattedOptions = e?.map(option => option.value).join(',');
                    formik.setFieldValue('organizationInformation', formattedOptions);
                  }}
                />
              </div>
            </div>
          )}

          <div className='row'>
            {Organization &&
              formik.values?.parameters?.map((param, index) => (
                <div className='col-xl-6' key={param.organizationCategoryId}>
                  <DynamicInput
                    param={param}
                    onChange={value => {
                      let processedValue;

                      if (['Account','Inventory'].includes(param?.type)) {
                        processedValue = value === null ? null : value.value;
                      } else {
                        processedValue = value;
                      }

                      const updatedParameters = formik.values.parameters?.map((p, i) =>
                        i === index ? { ...p, value: processedValue } : p
                      );

                      formik.setFieldValue('parameters', updatedParameters);
                    }}
                  />
                </div>
              ))}
          </div>

          <div className='col-xl-12'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('Note')}</label>
              <Form.Control
                className='form-control'
                type='text'
                autoComplete='off'
                name='description'
                onChange={formik.handleChange}
                value={formik.values.description || ''}
              />
            </div>
          </div>

        

          <div className='text-center mt-3'>
            <div className='d-flex justify-content-between gap-2'>
              <button
                disabled={formik.isSubmitting}
                type='submit'
                className='btn btn-lg btn-theme mb-1 w-100'
              >
                {formik.isSubmitting ? (
                  <div className='spinner-border spinner-border-sm me-2'></div>
                ) : (
                  <i className='fa fa-save fa-fw me-1'></i>
                )}
                {t('Save')}
              </button>
              <button
                type='button'
                className='btn btn-lg btn-default mb-1 w-100'
                id='closeModal'
                data-bs-dismiss='modal'
              >
                <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
              </button>
            </div>
          </div>
        </Form>
      </Loading>
    </>
  );
};

export default EditFormDepartments;
